import { forwardRef, Suspense, lazy } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import { CssBaseline } from '@mui/material'
import './AppRouter.css'

import NavBar from './NavBar'
import Loading from './Loading'
const Home = lazy(() => import('../routes/Home'))
const SearchList = lazy(() => import('../routes/SearchList'))
const StoreDetail = lazy(() => import('../routes/StoreDetail'))

//const Loading = lazy(() => import('../components/Loading'))

const AppRouter = forwardRef(({}, ref) => {
    return (
        <div ref={ref}>
            <Router>
                <div className="AppRouter-navigation-root">
                    {/*CssBaseline: 기본 마진을 제거*/}
                    <CssBaseline />
                    <NavBar />
                </div>

                <Suspense
                    fallback={
                        <>
                            <Loading />
                        </>
                    }
                >
                    {/* 라우터에 연결된 루트들*/}
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/store" element={<StoreDetail />} />
                        <Route path="/search" element={<SearchList />} />
                    </Routes>
                </Suspense>
            </Router>
        </div>
    )
})

export default AppRouter
